import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP111_Request,
  IAPI_APP111_Response,
  IAPI_COM005_Request,
  IAPI_COM005_Response,
  IAPI_PRE011_Request,
  IAPI_PRE011_Response,
} from "../../../type/apiType";

// 帳票ダウンロード(汎用)
const httpAPI_COM005 = async (
  param: IAPI_COM005_Request
): Promise<IAPI_COM005_Response> => {
  let res = await http.post(ApiUrl.API_COM005, {
    ...param,
  });

  return res.data;
};

// 掛金納付対象職員届提出控え・振込依頼書参照
const httpAPI_PRE011 = async (
  param: IAPI_PRE011_Request
): Promise<IAPI_PRE011_Response> => {
  let res = await http.post(ApiUrl.API_PRE011, {
    ...param,
  });

  return res.data;
};

// 掛金納付対象職員届提出控え、振込依頼書ダウンロード状況更新
const httpAPI_APP111 = async (
  param: IAPI_APP111_Request
): Promise<IAPI_APP111_Response> => {
  let res = await http.post(ApiUrl.API_APP111, {
    ...param,
  });

  return res.data;
};

export { httpAPI_COM005, httpAPI_PRE011, httpAPI_APP111 };
